import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { SuccessToast } from "../../../widgets/AppToast";
import AlramInput from "../../../components/AlramInput";
import TextAreaInput from "../../../components/TextAreaInput";
import { useNavigate } from "react-router-dom";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import { convertUTCToLocalDatetimeLocal } from "../../../utils/dateFormatter";
import AppInput from "../../../components/AppInput";

function AddSoundingLogBook() {
  const navigate = useNavigate();
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [loader, set_loader] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [subTankList, setSubTankList] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [logDate, set_LogDate] = useState(null);
  const [date_error, set_date_errors] = useState(null);
  const [previous_log_date, set_Previous_Log_Date] = useState("");

  const GET_PREVIUS_LOG_DATE = () => {
    const FORM_DATA = new FormData();
    post(ApiURL.staff_api_sounding_last_date_st, FORM_DATA).then((res) => {
      if (res?.status === true) {
        const previusDate = res?.laast_record;
        set_Previous_Log_Date(previusDate);
      }
    });
  };

  const getAlarmColor = (value, maxCapacity) => {
    if (!maxCapacity || maxCapacity <= 0) return { color: "gray", percent: 0 };
    const percent = (Number(value) / maxCapacity) * 100;
    const orangeThreshold = 80; // 80%
    const redThreshold = 95; // 95%
    let color = "green";
    if (percent >= redThreshold) {
      color = "red";
    } else if (percent >= orangeThreshold) {
      color = "orange";
    }
    return { color, percent: percent.toFixed(2) };
  };

  const LIST_SUB_TANKS_API = async () => {
    try {
      const FORM_DATA = new FormData();
      const staff_Details = JSON.parse(localStorage.getItem("user_data"));
      FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
      post(ApiURL.list_tanks_by_ship, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setSubTankList(res?.tanks);
        }
      });
    } catch (error) {
      console.error("Error fetching Sub Tanks list:", error);
    }
  };

  const handleInputChange = (tankId, value, type) => {
    setInputValues((prev) => ({
      ...prev,
      [tankId]: {
        ...prev[tankId],
        [type]: value,
      },
    }));
  };

  function findNestedObjects(obj) {
    let nestedObjects = [];
    for (let key in obj) {
      if (
        obj.hasOwnProperty(key) &&
        typeof obj[key] === "object" &&
        obj[key] !== null
      ) {
        if (obj[key].value) {
          let tankData = {
            tank_id: key,
            rob: obj[key].value,
          };
          if (obj[key].text) {
            tankData.comment = obj[key].text;
          }
          nestedObjects.push(tankData);
        }
      }
    }
    return nestedObjects;
  }

  const ADD_LEVEL_API = async () => {
    set_loader(true);
    const nestedArray = findNestedObjects(inputValues);
    try {
      const FORM_DATA = new FormData();
      const staff_Details = JSON.parse(localStorage.getItem("user_data"));

      if (!logDate || logDate.trim() === "") {
        set_loader(false);
        set_date_errors("Log Date Time is required!");
        return;
      }
      FORM_DATA.append("log_date_time", logDate);
      FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      nestedArray?.forEach((tanks) => {
        FORM_DATA.append("tank_record[]", JSON.stringify(tanks));
      });

      post(ApiURL.update_tank_rob_and_comment, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast(
            "Add Sub Tanks Level Success!",
            "Adding Sub Tank Level details have been successfully"
          );
          navigate("/list-sound-log");
          LIST_SUB_TANKS_API();
          setSubmitStatus(res?.updated_tanks?.submit_status);
        }
        set_loader(false);
      });
    } catch (error) {
      set_loader(false);
      console.error("Error Tanks Level:", error);
    }
  };

  useEffect(() => {
    GET_PREVIUS_LOG_DATE();
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    LIST_SUB_TANKS_API();
  }, []);

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  };

  const tableHeaderStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    backgroundColor: "#f4f4f4",
    fontWeight: "bold",
    textAlign: "center",
  };

  const tableCellStyle = {
    border: "1px solid #ddd",
    padding: "7px",
    textAlign: "center",
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <div className="row" style={{ alignItems: "center" }}>
          <div className="col-3">
            <h3>Sounding Logbook Information</h3>
          </div>
          <div className="col-4">
            <div className="input-box">
              <AppInput
                type="datetime-local"
                label="Date & Time"
                placeholder="Select Date and Time"
                value={logDate}
                onChange={(e) => set_LogDate(e.target.value)}
                errors={date_error}
                min={convertUTCToLocalDatetimeLocal(previous_log_date)}
                max={new Date().toISOString().slice(0, 16)}
              />
            </div>
          </div>
        </div>

        <div>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={tableHeaderStyle}>Tank Id</th>
                <th style={tableHeaderStyle}>Tank Name</th>
                <th style={tableHeaderStyle}>Capacity (m3)</th>
                <th style={tableHeaderStyle}>Remain On Board</th>
                <th style={tableHeaderStyle}>Comments</th>
              </tr>
            </thead>
            <tbody>
              {subTankList?.map((item) => {
                const maxCapacity = item?.capacity || 100;
                const value = inputValues[item?.id]?.value || "";
                const alarm = getAlarmColor(value, maxCapacity);
                return (
                  <tr key={item?.id}>
                    <td style={tableCellStyle}>{item?.id}</td>
                    <td style={tableCellStyle}>
                      {item?.sub_tank_name || "Fuel Oil Tank"}
                    </td>
                    <td style={tableCellStyle}>{maxCapacity}</td>
                    <td style={tableCellStyle}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <AlramInput
                          value={value}
                          placeholder="Level"
                          type="number"
                          step="any"
                          onChange={(e) => {
                            const newValue = e.target.value;
                            if (Number(newValue) > maxCapacity) return;
                            handleInputChange(item.id, newValue, "value");
                          }}
                          style={{
                            color: alarm.color,
                          }}
                          alarm_Data={{
                            max: maxCapacity,
                            orange: maxCapacity * 0.8,
                            red: maxCapacity * 0.95,
                          }}
                        />
                      </div>
                    </td>
                    <td style={tableCellStyle}>
                      <TextAreaInput
                        rows={1}
                        placeholder="Tanks Comments"
                        maxLength={1000}
                        value={inputValues[item?.id]?.text || ""}
                        onChange={(e) =>
                          handleInputChange(item.id, e.target.value, "text")
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="row">
            <div className="input-box" style={{ marginTop: "15px" }}>
              <Button
                loading={loader}
                disabled={submitStatus}
                type="primary"
                className="save_btn"
                style={{ color: "white", marginLeft: "10px" }}
                onClick={() => ADD_LEVEL_API()}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddSoundingLogBook;
